'use client';

import { useState } from 'react';
import { usePathname } from 'next/navigation';

import { useModalStore } from '@/store/modal.store';
import { useAuth } from '@/hooks/use-auth';
import { useProfile } from '@/hooks/use-profile';
import { useTheme } from '@/hooks/use-theme';
import { useBodyScrollLock } from '@/hooks/use-body-scroll-lock';
import { MobileHeader } from './header/mobile-header';
import { DesktopHeader } from './header/desktop-header';
import { MobileMenu } from './header/mobile-menu';
import { VrnfestHeader } from './header/vrnfest-header';
import { sendYandexMetrica } from '@/utils/send-metrika-yandex.utils';

export default function Header() {
  const pathname = usePathname();
  const isVrnfest = pathname === '/vrnfest' || pathname.startsWith('/vrnfest/');

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const { setIsOpenAuthDialog } = useModalStore();
  const { user, isAuthenticated, logout } = useAuth();
  const { userData } = useProfile();
  const { theme, isDark, toggleTheme, mounted } = useTheme();

  useBodyScrollLock(mobileMenuOpen && !isVrnfest);

  const handleSearchStateChange = (isActive: boolean) => {
    setIsSearchActive(isActive);
  };

  const openAuthDialog = () => {
    setIsOpenAuthDialog(true);
    sendYandexMetrica({ params: 'all_header_singup_click' });
  };

  if (isVrnfest) {
    return (
      <header
        style={{ height: 'var(--header-height)' }}
        className="h-full w-full bg-[#1B1D22] py-[42px]"
      >
        <div className="mx-auto flex h-full w-full max-w-[1200px] items-center px-4 sm:px-10 lg:px-1 min-[1095px]:px-10">
          <VrnfestHeader />
        </div>
      </header>
    );
  }

  return (
    <>
      <header
        style={{ height: 'var(--header-height)' }}
        className="bg-[#1B1D22] py-4 w-full h-full"
      >
        <div className="mx-auto flex h-full w-full max-w-[1920px] items-center justify-between px-4 sm:px-10 lg:px-1 min-[1095px]:px-10">
          <MobileHeader
            isSearchActive={isSearchActive}
            onSearchStateChange={handleSearchStateChange}
            isAuthenticated={isAuthenticated}
            userData={userData}
            user={user}
            onOpenAuthDialog={() => setIsOpenAuthDialog(true)}
            onToggleMobileMenu={() => setMobileMenuOpen(!mobileMenuOpen)}
            onLogout={logout}
          />

          <DesktopHeader
            isAuthenticated={isAuthenticated}
            userData={userData}
            user={user}
            onOpenAuthDialog={openAuthDialog}
            onLogout={logout}
            theme={theme}
            isDark={isDark}
            toggleTheme={toggleTheme}
            mounted={mounted}
            isSearchActive={isSearchActive}
            onSearchStateChange={handleSearchStateChange}
          />
        </div>
      </header>

      <MobileMenu
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        // isDark={isDark}
        // toggleTheme={toggleTheme}
        // mounted={mounted}
        isAuthenticated={isAuthenticated}
      />
    </>
  );
}
